//Material editor's main purpose is to reflect the properties of a single material asset

import React, { useEffect, useRef, useState } from 'react';
import { shallowEqual } from 'react-redux';
import * as THREE from 'three';
import MaterialProperty from './MaterialProperty';
import MaterialStructure from './MaterialStructure';
import MaterialLivePreview from './MaterialLivePreview';
import {useTypedSelector} from "../../state/hooks";
import Spacer from '../layout/Spacer';
interface MaterialEditorProps {
	id: string;
	scale?: number;
	materialAssetButton?: JSX.Element;
}

export default function MaterialEditor(props: MaterialEditorProps)
{
	const materialProperties: { [key: string]: { [key: string]: any } } = useTypedSelector(state => state.materialsModule.materials[props.id], shallowEqual);

	function generateProperties()
	{
		const properties: JSX.Element[] = [];
		if (materialProperties)
		{
			for (const key of Object.keys(materialProperties))
			{
				const property = materialProperties[key];

				//check if the property should be displayed for the given material type
				if (MaterialStructure[materialProperties.type.value].includes(key))
				{
					properties.push(
						<MaterialProperty
							data-name={'material-editor'}
							key={key}
							id={props.id}
							name={key}
							property={property}
						/>,
					);
				}
			}
		}

		return properties;
	}

	const adjustHeight = () => 
	{
		if (!props.scale) return undefined;
		const normalizedHeight = (props.scale + 1) / 7;
		const height = 16 + (normalizedHeight * (256 - 16));
		return height;
	}

	const [forcedHeight, setForcedHeight] = useState<number | undefined>(adjustHeight());

	useEffect(() =>
	{
		if (!props.scale) 
		{
			setForcedHeight(undefined); 
			return;
		}
		setForcedHeight(adjustHeight());
	}, [props.scale]);



	return (
		<div className={"materialPropertiesRoot"}>
			{props.id && <MaterialLivePreview materialId={props.id} forcedHeight={forcedHeight} properties={materialProperties} />}
			<Spacer size={{y: "5px"}} />
			{props.materialAssetButton}
			<Spacer size={{y: "5px"}} />
			{
				generateProperties()
			}
		</div>
	)
}
